<template>
	<div class="chat-header">
		<div class="chat-header-icon">
			<CommentsIcon class="dm-icon" v-if="isDM" type="regular" />
			<UserGroupIcon class="group-icon" v-else type="regular" />
		</div>

		<div class="chat-header-title">
			{{ displayTitle }}
		</div>

		<!-- Slot for specific implementation details -->
		<slot></slot>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import { CommentsIcon, UserGroupIcon } from '@/icons'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
	isDM: Boolean,
	title: String,
})

//computed properties
const displayTitle = computed(() => {
	return props.isDM ? t('chat_stream_header_title_dm') : props.title
})
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';
.chat-header {
	padding: 1rem;
	.chat-header-title {
		font-family: Avenir-Heavy;
		font-size: 28px;
		color: var(--neutral-800);
	}

	.chat-header-icon {
		font-size: 30px;
		color: var(--teal-300);
	}
}
</style>
